import React, {Component} from 'react';
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../../components/calendar/Calendar";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../components/textbox/Input";
import Utils from "../../../../../../utils/Utils"
import ICD9Procedure from "../../../../../../utils/ICD9-procedure.json"
import OggettiUtili from "../../../../../../utils/OggettiUtili.json"


import {withTranslation} from "react-i18next";
import Autocomplete from "../../../../../../components/autocomplete/Autocomplete";
import icd9 from "../../../../../../utils/ICD9-diagnosi.json";
import Select from "../../../../../../components/select/Select";
import SelectAutocomplete from "../../../../../../components/selectAutocomplete/SelectAutocomplete";
import SessioneUtente from "../../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../../utils/Ruoli.json";

const procedure_icd9 = ICD9Procedure.procedure.sort(Utils.SorterObjectDesc)

class SezioneSei extends Component {
    state = {
        sezioneSei: {
            somministrazione: "",
            somministrazioneDerivati: "",
            interventi: "",
            descIntervento: "",
            tipoIntervento: "",
            endoscopia: "",
            descEndoscopia: "",
            tipoEndoscopia: "",
            ospedalizzato: "02",
            listaOspedalizzato: [
                {ospedaleTipo: "", repartoTipo: "", dataOspedalizzato: ""},
                {ospedaleTipo: "", repartoTipo: "", dataOspedalizzato: ""},
                {ospedaleTipo: "", repartoTipo: "", dataOspedalizzato: ""}
            ],
            droghe: "",
            modalita: "",
            contatti: "",
            trattamento: "",
            piercing: "",
            tatuaggio: "",
            agoPuntura: "",
            barbiere: "",
            callista: "",
            emodializzato: "",
            corretto: []
        },
        controlloAutocomplete: {
            descIntervento: true,
            descEndoscopia: true,
            ospedaleTipo0: true,
            repartoTipo0: true,
            ospedaleTipo1: true,
            repartoTipo1: true,
            ospedaleTipo2: true,
            repartoTipo2: true
        },
        descInterventoPerCodice: Utils.arrayToMap(procedure_icd9, "codice"),
        struttureAndStabilimenti: JSON.parse(sessionStorage.getItem("struttureAndStabilimenti")),
        struttureAndStabilimentiPerCodice: JSON.parse(sessionStorage.getItem("struttureAndStabilimentiPerCodice")),
        reparti: JSON.parse(sessionStorage.getItem("reparti")),
        repartiPerCodice: JSON.parse(sessionStorage.getItem("repartiPerCodice")),
    }


    constructor(props) {
        super(props);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.controllaDati = this.controllaDati.bind(this);
        this.createJsonBackend = this.createJsonBackend.bind(this)
        this.validate = this.validate.bind(this)
    }

    componentDidMount() {
        let sezioneSei = this.state.sezioneSei
        let controlloAutocomplete = this.state.controlloAutocomplete
        let datiSanitari = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.datiSanitari))
        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.sezioneSei) {
            let propsSezione = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.sezioneSei))
            sezioneSei.somministrazione = propsSezione.somministrazione ? propsSezione.somministrazione : ""
            sezioneSei.somministrazioneDerivati = propsSezione.somministrazioneDerivati ? propsSezione.somministrazioneDerivati : ""
            sezioneSei.interventi = propsSezione.interventi ? propsSezione.interventi : ""
            sezioneSei.descIntervento = propsSezione.descIntervento && this.state.descInterventoPerCodice[propsSezione.descIntervento] ? this.state.descInterventoPerCodice[propsSezione.descIntervento] : propsSezione.descIntervento ? propsSezione.descIntervento : ""
            controlloAutocomplete.descIntervento = propsSezione.descIntervento && this.state.descInterventoPerCodice[propsSezione.descIntervento] ? true : false
            sezioneSei.tipoIntervento = propsSezione.tipoIntervento ? propsSezione.tipoIntervento : ""
            sezioneSei.endoscopia = propsSezione.endoscopia ? propsSezione.endoscopia : ""
            sezioneSei.descEndoscopia = propsSezione.descEndoscopia ? propsSezione.descEndoscopia : ""
            controlloAutocomplete.descEndoscopia = propsSezione.descEndoscopia && Utils.arrayToMap(OggettiUtili.tipologiaEndoscopica, "codice")[propsSezione.descEndoscopia] ? true : false
            sezioneSei.tipoEndoscopia = propsSezione.tipoEndoscopia ? propsSezione.tipoEndoscopia : ""
            sezioneSei.ospedalizzato = propsSezione.ospedalizzato ? propsSezione.ospedalizzato : ""
            sezioneSei.droghe = propsSezione.droghe ? propsSezione.droghe : ""
            sezioneSei.modalita = propsSezione.modalita ? propsSezione.modalita : ""
            sezioneSei.contatti = propsSezione.contatti ? propsSezione.contatti : ""
            sezioneSei.trattamento = propsSezione.trattamento ? propsSezione.trattamento : ""
            sezioneSei.piercing = propsSezione.piercing ? propsSezione.piercing : ""
            sezioneSei.tatuaggio = propsSezione.tatuaggio ? propsSezione.tatuaggio : ""
            sezioneSei.agoPuntura = propsSezione.agoPuntura ? propsSezione.agoPuntura : ""
            sezioneSei.barbiere = propsSezione.barbiere ? propsSezione.barbiere : ""
            sezioneSei.callista = propsSezione.callista ? propsSezione.callista : ""
            sezioneSei.emodializzato = propsSezione.emodializzato ? propsSezione.emodializzato : ""
            if (propsSezione.listaOspedalizzato) {
                for (let i = 0; i < propsSezione.listaOspedalizzato.length; i++) {
                    sezioneSei.listaOspedalizzato[i].ospedaleTipo = propsSezione.listaOspedalizzato[i].ospedaleTipo && this.state.struttureAndStabilimentiPerCodice[propsSezione.listaOspedalizzato[i].ospedaleTipo] ? this.state.struttureAndStabilimentiPerCodice[propsSezione.listaOspedalizzato[i].ospedaleTipo] : propsSezione.listaOspedalizzato[i].ospedaleTipo ? propsSezione.listaOspedalizzato[i].ospedaleTipo : ""
                    sezioneSei.listaOspedalizzato[i].repartoTipo = propsSezione.listaOspedalizzato[i].repartoTipo ? propsSezione.listaOspedalizzato[i].repartoTipo : ""
                    sezioneSei.listaOspedalizzato[i].dataOspedalizzato = propsSezione.listaOspedalizzato[i].dataOspedalizzato ? propsSezione.listaOspedalizzato[i].dataOspedalizzato : ""
                }
                controlloAutocomplete.ospedaleTipo0 = sezioneSei.listaOspedalizzato[0].ospedaleTipo && this.state.struttureAndStabilimentiPerCodice[propsSezione.listaOspedalizzato[0].ospedaleTipo] ? true : false
                controlloAutocomplete.ospedaleTipo1 = sezioneSei.listaOspedalizzato[1].ospedaleTipo && this.state.struttureAndStabilimentiPerCodice[propsSezione.listaOspedalizzato[1].ospedaleTipo] ? true : false
                controlloAutocomplete.ospedaleTipo2 = sezioneSei.listaOspedalizzato[2].ospedaleTipo && this.state.struttureAndStabilimentiPerCodice[propsSezione.listaOspedalizzato[2].ospedaleTipo] ? true : false
                controlloAutocomplete.repartoTipo0 = sezioneSei.listaOspedalizzato[0].repartoTipo && Utils.arrayToMap(OggettiUtili.repartoSEIVA, "codice")[sezioneSei.listaOspedalizzato[0].repartoTipo] ? true : false
                controlloAutocomplete.repartoTipo1 = sezioneSei.listaOspedalizzato[1].repartoTipo && Utils.arrayToMap(OggettiUtili.repartoSEIVA, "codice")[sezioneSei.listaOspedalizzato[1].repartoTipo] ? true : false
                controlloAutocomplete.repartoTipo2 = sezioneSei.listaOspedalizzato[2].repartoTipo && Utils.arrayToMap(OggettiUtili.repartoSEIVA, "codice")[sezioneSei.listaOspedalizzato[2].repartoTipo] ? true : false

            }
        } else if (datiSanitari && datiSanitari.ricovero && datiSanitari.ricovero === "1" && datiSanitari.dataRicovero) {
            let mesiDifferenza = Utils.monthDiff(new Date(Utils.transformDateForBackend(datiSanitari.dataInizioSintomi)), new Date(Utils.transformDateForBackend(datiSanitari.dataRicovero)))
            if (mesiDifferenza >= 0 && mesiDifferenza < 7) {

                var giorniDataInizioSintomi = Utils.DateToDays(datiSanitari.dataInizioSintomi)
                var giorniDataRicovero = Utils.DateToDays(datiSanitari.dataRicovero)
                var giorniDifferenza = giorniDataRicovero - giorniDataInizioSintomi

                if (giorniDifferenza > 0) {
                    sezioneSei.ospedalizzato = datiSanitari.ricovero === "1" ? "01" : datiSanitari.ricovero === "2" ? "02" : datiSanitari.ricovero === "3" ? "03" : ""
                    sezioneSei.listaOspedalizzato[0].ospedaleTipo = datiSanitari.struttura && this.state.struttureAndStabilimentiPerCodice[datiSanitari.struttura] ? this.state.struttureAndStabilimentiPerCodice[datiSanitari.struttura] : ""

                    if (datiSanitari.reparto && this.state.repartiPerCodice[datiSanitari.reparto]) {
                        let repartiPerDescrizione = Utils.arrayToMap(OggettiUtili.repartoSEIVA, "descrizione")
                        if (repartiPerDescrizione[this.state.repartiPerCodice[datiSanitari.reparto].descrizione.toUpperCase()]) {
                            sezioneSei.listaOspedalizzato[0].repartoTipo = repartiPerDescrizione[this.state.repartiPerCodice[datiSanitari.reparto].descrizione.toUpperCase()].codice
                        }
                    }

                    sezioneSei.listaOspedalizzato[0].dataOspedalizzato = datiSanitari.dataRicovero ? Utils.transformDateForFrontend(datiSanitari.dataRicovero) : ""
                }
            }

        }

        this.setState({sezioneSei: sezioneSei, controlloAutocomplete: controlloAutocomplete});
        this.controllaDati()
        this.props.setSezioneSei(this.state.sezioneSei)

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.controllaDati();
        if (prevState !== this.state) {
            let res = this.createJsonBackend()
            this.props.setSezioneSei(this.state.sezioneSei, this.validate(), res)
        }

    }

    validate() {

        for (let i = 0; i < this.state.sezioneSei.listaOspedalizzato.length; i++) {
            if (this.state.sezioneSei.listaOspedalizzato[i].dataOspedalizzato) {
                let validatedataOspedalizzato = Utils.checkDateInterval(this.state.sezioneSei.listaOspedalizzato[i].dataOspedalizzato, "31/12/1899");
                let validatedataOspedalizzatoOdierna = Utils.checkDateInterval(this.state.sezioneSei.listaOspedalizzato[i].dataOspedalizzato, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

                if (validatedataOspedalizzato) {
                    return "Messages.DataOspedalizzato"
                } else if (!validatedataOspedalizzatoOdierna) {
                    return "Messages.DataOspedalizzatoOdierna"
                }
            }
        }

        if (this.state.sezioneSei.interventi !== "01" && this.state.sezioneSei.descIntervento && this.state.sezioneSei.tipoIntervento) return "Messages.ERR_01_02_0D_AC"
        else if (this.state.sezioneSei.endoscopia !== "01" && this.state.sezioneSei.descEndoscopia && this.state.sezioneSei.tipoEndoscopia) return "Messages.ERR_01_02_0D_AD"
        else if (this.state.sezioneSei.ospedalizzato !== "01") {
            if (this.state.sezioneSei.listaOspedalizzato[0].ospedaleTipo || this.state.sezioneSei.listaOspedalizzato[1].ospedaleTipo || this.state.sezioneSei.listaOspedalizzato[2].ospedaleTipo) return "Messages.ERR_01_02_0D_AE"
            else if (this.state.sezioneSei.listaOspedalizzato[0].repartoTipo || this.state.sezioneSei.listaOspedalizzato[1].repartoTipo || this.state.sezioneSei.listaOspedalizzato[2].repartoTipo) return "Messages.ERR_01_02_0D_AF"
            else if (this.state.sezioneSei.listaOspedalizzato[0].dataOspedalizzato || this.state.sezioneSei.listaOspedalizzato[1].dataOspedalizzato || this.state.sezioneSei.listaOspedalizzato[2].dataOspedalizzato) return "Messages.ERR_01_02_0D_AG"
        }
        if (this.state.sezioneSei.droghe !== "01" && this.state.sezioneSei.modalita) return "Messages.ERR_01_02_0D_AH"
        else if (this.state.sezioneSei.droghe !== "01" && this.state.sezioneSei.contatti) return "Messages.ERR_01_02_0D_AI"

        return ""

    }


    createJsonBackend() {
        let dati = JSON.parse(JSON.stringify(this.state.sezioneSei))
        let ObjectForBackEnd = {}
        ObjectForBackEnd["somministrazione"] = dati.somministrazione
        ObjectForBackEnd["interventi"] = dati.interventi
        ObjectForBackEnd["descIntervento"] = dati.descIntervento.codice
        ObjectForBackEnd["tipoIntervento"] = dati.tipoIntervento
        ObjectForBackEnd["somministrazioneDerivati"] = dati.somministrazioneDerivati
        ObjectForBackEnd["endoscopia"] = dati.endoscopia
        ObjectForBackEnd["notte"] = dati.notte
        ObjectForBackEnd["descEndoscopia"] = dati.descEndoscopia
        ObjectForBackEnd["tipoEndoscopia"] = dati.tipoEndoscopia
        ObjectForBackEnd["ospedalizzato"] = dati.ospedalizzato
        ObjectForBackEnd["droghe"] = dati.droghe
        ObjectForBackEnd["modalita"] = dati.modalita
        ObjectForBackEnd["contatti"] = dati.contatti
        ObjectForBackEnd["trattamento"] = dati.trattamento
        ObjectForBackEnd["piercing"] = dati.piercing
        ObjectForBackEnd["tatuaggio"] = dati.tatuaggio
        ObjectForBackEnd["agoPuntura"] = dati.agoPuntura
        ObjectForBackEnd["barbiere"] = dati.barbiere
        ObjectForBackEnd["callista"] = dati.callista
        ObjectForBackEnd["emodializzato"] = dati.emodializzato
        let listaOsp = []
        dati.listaOspedalizzato.forEach(el => {
            let newElemento = el
            newElemento.ospedaleTipo = el.ospedaleTipo && el.ospedaleTipo.codice ? el.ospedaleTipo.codice : ""
            listaOsp.push(newElemento)
        })
        ObjectForBackEnd["listaOspedalizzato"] = Utils.removeEmptyValueFromObject(listaOsp)
        let sezioneBackend = Utils.removeEmptyValueFromObject(ObjectForBackEnd)
        return Utils.removeFieldFromObject(sezioneBackend, "corretto")
    }

    controllaDati() {

        let dati = this.state.sezioneSei
        dati.corretto = []

        if (dati.interventi === "01" && (!dati.descIntervento || !dati.tipoIntervento)) dati.corretto[0] = "Campo \"Se sì, specificare il tipo di intervento\" mancante";
        if (dati.endoscopia === "01" && (!dati.descEndoscopia || !dati.tipoEndoscopia)) dati.corretto[1] = "Campo \"Se sì, specificare il tipo di endoscopia\" mancante";
        if (dati.ospedalizzato === "01" &&
            (!dati.listaOspedalizzato[0].repartoTipo || !dati.listaOspedalizzato[0].ospedaleTipo ||
                (Utils.isDateInValid(Utils.transformDateForBackend(dati.listaOspedalizzato[0].dataOspedalizzato), "-")) ||
                (dati.listaOspedalizzato[1].dataOspedalizzato !== "" && Utils.isDateInValid(Utils.transformDateForBackend(dati.listaOspedalizzato[0].dataOspedalizzato), "-"))) ||
            (dati.listaOspedalizzato[2].dataOspedalizzato !== "" && Utils.isDateInValid(Utils.transformDateForBackend(dati.listaOspedalizzato[0].dataOspedalizzato), "-"))
        ) dati.corretto[2] = "Campo \"Ospedale\" o \"Reparto\" o \"Quando\" mancante";
        if (dati.droghe === "01" && !dati.modalita) dati.corretto[3] = "Campo \"Se sì, modalità di assunzione\" mancante";
        if (dati.droghe === "01" && !dati.contatti) dati.corretto[4] = "Campo \"Se sì, ha mai avuto contatto con un SERT?\" mancante";

    }


    riceviValoreRadioButton(event, field) {
        let sezioneSei = this.state.sezioneSei
        sezioneSei[field] = event

        if (sezioneSei.interventi !== "01") {
            sezioneSei.tipoIntervento = ""
        }

        if (sezioneSei.endoscopia !== "01") {
            sezioneSei.tipoEndoscopia = ""
        }


        if (sezioneSei.droghe !== "01") {
            sezioneSei.modalita = ""
            sezioneSei.contatti = ""
        }

        this.setState({sezioneSei: sezioneSei})
    }

    riceviValoreInput(field, event) {

        let sezioneSei = this.state.sezioneSei
        let controlloAutocomplete = this.state.controlloAutocomplete
        if (field.currentTarget) {
            if (field.currentTarget.id.includes("dataOspedalizzato")) {
                let indice = parseInt(field.currentTarget.id.replace("dataOspedalizzato", ""))
                sezioneSei.listaOspedalizzato[indice].dataOspedalizzato = field.currentTarget.value
            } else {
                sezioneSei[field.currentTarget.id] = field.currentTarget.value
            }
        } else {
            if (field.includes("ospedaleTipo")) {
                let indice = parseInt(field.replace("ospedaleTipo", ""))
                if (!event.target.value) {
                    if (indice === 0) controlloAutocomplete.ospedaleTipo0 = true
                    else if (indice === 1) controlloAutocomplete.ospedaleTipo1 = true
                    else if (indice === 2) controlloAutocomplete.ospedaleTipo2 = true
                }
                sezioneSei.listaOspedalizzato[indice].ospedaleTipo = event.target.value
            } else if (field.includes("repartoTipo")) {
                let indice = parseInt(field.replace("repartoTipo", ""))
                if (!event.target.value) {
                    if (indice === 0) controlloAutocomplete.repartoTipo0 = true
                    else if (indice === 1) controlloAutocomplete.repartoTipo1 = true
                    else if (indice === 2) controlloAutocomplete.repartoTipo2 = true
                }
                sezioneSei.listaOspedalizzato[indice].repartoTipo = event.target.value
            } else if (field.includes("descIntervento") && !event.target.value) {
                controlloAutocomplete.descIntervento = true
            } else if (field.includes("descEndoscopia") && !event.target.value) {
                controlloAutocomplete.descEndoscopia = true
            } else {
                sezioneSei[field] = event.target.value
            }
        }
        this.setState({sezioneSei: sezioneSei, controlloAutocomplete: controlloAutocomplete})
    }


    render() {

        const {t} = this.props;

        const sezioneSei = (
            <div style={{marginTop: "10px"}}>
                <div>
                    <h6>Sezione 6 - Durante i 6 mesi prima dell'inizio della malattia</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6"><p className={styles.labelHeader} style={{marginTop: "10px"}}>
                            <b>{t("SchedaEpatite.sezione6.domandaUno")}</b></p></div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"somministrazioneSi"}
                                             name={"somministrazione"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "somministrazione")}
                                             checked={this.state.sezioneSei.somministrazione === "01"}>
                                </RadioButton>
                                <RadioButton id={"somministrazioneNo"}
                                             name={"somministrazione"} label={t("SchedaEpatite.risposteTipoUno.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "somministrazione")}
                                             checked={this.state.sezioneSei.somministrazione === "02"}
                                />
                                <RadioButton id={"somministrazioneNonSo"}
                                             name={"somministrazione"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
                                             value={"03"}
                                             onClick={() => this.riceviValoreRadioButton("03", "somministrazione")}
                                             checked={this.state.sezioneSei.somministrazione === "03"}
                                />
                            </div>
                        </div>


                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione6.domandaDue")}</b></p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row" style={{marginTop: "10px"}}>
                                <RadioButton id={"somministrazioneDerivatiSi"}
                                             name={"somministrazioneDerivati"}
                                             label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "somministrazioneDerivati")}
                                             checked={this.state.sezioneSei.somministrazioneDerivati === "01"}>
                                </RadioButton>
                                <RadioButton id={"somministrazioneDerivatiNo"}
                                             name={"somministrazioneDerivati"}
                                             label={t("SchedaEpatite.risposteTipoUno.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "somministrazioneDerivati")}
                                             checked={this.state.sezioneSei.somministrazioneDerivati === "02"}
                                />
                                <RadioButton id={"somministrazioneDerivatiNonSo"}
                                             name={"somministrazioneDerivati"}
                                             label={t("SchedaEpatite.risposteTipoUno.nonso")}
                                             onClick={() => this.riceviValoreRadioButton("03", "somministrazioneDerivati")}
                                             checked={this.state.sezioneSei.somministrazioneDerivati === "03"}
                                             checked={false}
                                />

                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6" style={{marginTop: "10px"}}>
                            <p className={styles.labelHeader}>
                                <b>{t("SchedaEpatite.sezione6.domandaTre")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"interventiSi"}
                                             name={"interventi"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "interventi")}
                                             checked={this.state.sezioneSei.interventi === "01"}>
                                </RadioButton>
                                <RadioButton id={"interventiNo"}
                                             name={"interventi"} label={t("SchedaEpatite.risposteTipoUno.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "interventi")}
                                             checked={this.state.sezioneSei.interventi === "02"}
                                />
                                <RadioButton id={"interventiNonSo"}
                                             name={"interventi"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
                                             value={"03"}
                                             onClick={() => this.riceviValoreRadioButton("03", "interventi")}
                                             checked={this.state.sezioneSei.interventi === "03"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <div className="row" style={{marginTop: "10px"}}>
                                <div className="col-lg-6">
                                    <b>{t("SchedaEpatite.sezione6.siInterventi")}</b>
                                    {this.state.sezioneSei.interventi === "01" ?
                                        <span className={styles.mandatoryColor}>*</span> : ""}
                                </div>
                                <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                    {(this.state.sezioneSei.descIntervento && this.state.sezioneSei.descIntervento.codice) || !this.state.sezioneSei.descIntervento || this.state.controlloAutocomplete.descIntervento ?

                                        <Autocomplete
                                            id={"descIntervento"}
                                            field={"descIntervento"}
                                            onChange={this.riceviValoreInput}
                                            value={this.state.sezioneSei.descIntervento}
                                            placeholder={"Descrizione"}
                                            keyField={"codice"}
                                            descriptionField={"descrizione"}
                                            suggestionField={"descrizione"}
                                            suggestions={procedure_icd9}
                                        />
                                        :
                                        <Input
                                            id={"descIntervento"}
                                            onChange={this.riceviValoreInput}
                                            field={"descIntervento"}
                                            value={this.state.sezioneSei.descIntervento}
                                            placeholder={"Descrizione"}
                                        >
                                        </Input>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6" style={{paddingLeft: "0px"}}>
                            <div className="row">
                                <RadioButton id={"tipoIntervento1"}
                                             name={"tipoIntervento"} label={"Ambulatoriale"}
                                             value={"01"}
                                             disabled={this.state.sezioneSei.interventi !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "tipoIntervento")}
                                             checked={this.state.sezioneSei.tipoIntervento === "01"}>
                                </RadioButton>
                                <RadioButton id={"tipoIntervento2"}
                                             name={"tipoIntervento"} label={"Con ricovero"}
                                             value={"02"}
                                             disabled={this.state.sezioneSei.interventi !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("02", "tipoIntervento")}
                                             checked={this.state.sezioneSei.tipoIntervento === "02"}
                                />

                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6" style={{marginTop: "10px"}}>
                            <p className={styles.labelHeader}>
                                <b>{t("SchedaEpatite.sezione6.domandaQuattro")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"endoscopiaSi"}
                                             name={"endoscopia"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "endoscopia")}
                                             checked={this.state.sezioneSei.endoscopia === "01"}>
                                </RadioButton>
                                <RadioButton id={"endoscopiaNo"}
                                             name={"endoscopia"} label={t("SchedaEpatite.risposteTipoUno.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "endoscopia")}
                                             checked={this.state.sezioneSei.endoscopia === "02"}
                                />
                                <RadioButton id={"endoscopiaNonSo"}
                                             name={"endoscopia"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
                                             value={"03"}
                                             onClick={() => this.riceviValoreRadioButton("03", "endoscopia")}
                                             checked={this.state.sezioneSei.endoscopia === "03"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <div className="row" style={{marginTop: "10px"}}>
                                <div className="col-lg-6">
                                    <b>{t("SchedaEpatite.sezione6.siEndoscopia")}</b>
                                    {this.state.sezioneSei.endoscopia === "01" ?
                                        <span className={styles.mandatoryColor}>*</span> : ""}
                                </div>
                                <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                    {(this.state.sezioneSei.descEndoscopia && Utils.arrayToMap(OggettiUtili.tipologiaEndoscopica, "codice")[this.state.sezioneSei.descEndoscopia]) || !this.state.sezioneSei.descEndoscopia || this.state.controlloAutocomplete.descEndoscopia ?

                                        <Select
                                            value={this.state.sezioneSei.descEndoscopia}
                                            onChange={this.riceviValoreInput}
                                            id={"descEndoscopia"}
                                            style={{width: "100%"}}
                                            functionMap={OggettiUtili.tipologiaEndoscopica.sort(Utils.SorterObjectDesc).map((oggetto) => {
                                                return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                            })}
                                        />
                                        :
                                        <Input
                                            id={"descEndoscopia"}
                                            onChange={this.riceviValoreInput}
                                            field={"descEndoscopia"}
                                            value={this.state.sezioneSei.descEndoscopia}
                                            placeholder={"Descrizione"}
                                        >
                                        </Input>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6" style={{paddingLeft: "0px"}}>
                            <div className="row">
                                <RadioButton id={"tipoEndoscopia1"}
                                             name={"tipoEndoscopia"} label={"Ambulatoriale"}
                                             value={"01"}
                                             disabled={this.state.sezioneSei.endoscopia !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "tipoEndoscopia")}
                                             checked={this.state.sezioneSei.tipoEndoscopia === "01"}>
                                </RadioButton>
                                <RadioButton id={"tipoEndoscopia2"}
                                             name={"tipoEndoscopia"} label={"Con ricovero"}
                                             value={"02"}
                                             disabled={this.state.sezioneSei.endoscopia !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("02", "tipoEndoscopia")}
                                             checked={this.state.sezioneSei.tipoEndoscopia === "02"}
                                />

                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione6.domandaCinque")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"ospedalizzatoSi"}
                                             name={"ospedalizzato"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "ospedalizzato")}
                                             checked={this.state.sezioneSei.ospedalizzato === "01"}>
                                </RadioButton>
                                <RadioButton id={"ospedalizzatoNo"}
                                             name={"ospedalizzato"} label={t("SchedaEpatite.risposteTipoUno.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "ospedalizzato")}
                                             checked={this.state.sezioneSei.ospedalizzato === "02"}
                                />
                                <RadioButton id={"ospedalizzatoNonSo"}
                                             name={"ospedalizzato"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
                                             value={"03"}
                                             onClick={() => this.riceviValoreRadioButton("03", "ospedalizzato")}
                                             checked={this.state.sezioneSei.ospedalizzato === "03"}
                                />
                            </div>
                        </div>


                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                {t("SchedaEpatite.seSi")}:
                            </p>

                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-4">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                        <b>  {t("SchedaEpatite.sezione6.ospedale")}: </b>
                                        {this.state.sezioneSei.ospedalizzato === "01" ?
                                            <span className={styles.mandatoryColor}>*</span> : ""}
                                    </p>
                                </div>
                                <div className={`col-lg-7 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                                    {(this.state.sezioneSei.listaOspedalizzato[0].ospedaleTipo && this.state.sezioneSei.listaOspedalizzato[0].ospedaleTipo.codice) || !this.state.sezioneSei.listaOspedalizzato[0].ospedaleTipo || this.state.controlloAutocomplete.ospedaleTipo0 ?

                                        <Autocomplete id={"ospedaleTipo0"}
                                                      value={this.state.sezioneSei.listaOspedalizzato[0].ospedaleTipo}
                                                      keyField={"codice"}
                                                      descriptionField={"descrizione"}
                                                      suggestionField={"descrizione"}
                                                      onChange={this.riceviValoreInput}
                                                      field={"ospedaleTipo0"}
                                                      placeholder={"Ospedale"}
                                                      suggestions={this.state.struttureAndStabilimenti}
                                        />
                                        :
                                        <Input
                                            id={"ospedaleTipo0"}
                                            field={"ospedaleTipo0"}
                                            onChange={this.riceviValoreInput}
                                            value={this.state.sezioneSei.listaOspedalizzato[0].ospedaleTipo}
                                            placeholder={"Ospedale"}
                                        >
                                        </Input>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                        <b> {t("SchedaEpatite.sezione6.reparto")}: </b> {this.state.sezioneSei.ospedalizzato === "01" ?
                                        <span className={styles.mandatoryColor}>*</span> : ""}
                                    </p>
                                </div>
                                <div className={`col-lg-7 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                    {(this.state.sezioneSei.listaOspedalizzato[0].repartoTipo && Utils.arrayToMap(OggettiUtili.repartoSEIVA, "codice")[this.state.sezioneSei.listaOspedalizzato[0].repartoTipo]) || !this.state.sezioneSei.listaOspedalizzato[0].repartoTipo || this.state.controlloAutocomplete.repartoTipo0 ?

                                        <SelectAutocomplete
                                            id={"repartoTipo0"}
                                            field={"repartoTipo0"}
                                            newSelect={true}
                                            onChange={this.riceviValoreInput}
                                            value={this.state.sezioneSei.listaOspedalizzato[0].repartoTipo}
                                            functionMap={Utils.sortByKey(OggettiUtili.repartoSEIVA, "descrizione").map((oggetto) => {
                                                return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                            })}/>
                                        :
                                        <Input
                                            id={"repartoTipo0"} field={"repartoTipo0"} onChange={this.riceviValoreInput}
                                            value={this.state.sezioneSei.listaOspedalizzato[0].repartoTipo}
                                            placeholder={"Reparto"}
                                        >
                                        </Input>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                        <b> {t("SchedaEpatite.sezione6.quando")}:</b>
                                        {this.state.sezioneSei.ospedalizzato === "01" ?
                                            <span className={styles.mandatoryColor}>*</span> : ""}
                                    </p>
                                </div>
                                <div className={`col-lg-7 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                    <Calendar
                                        id="dataOspedalizzato0"
                                        field={"dataOspedalizzato0"}
                                        value={this.state.sezioneSei.listaOspedalizzato[0].dataOspedalizzato}
                                        onChange={this.riceviValoreInput}
                                        errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                            "Data")}
                                        error={(this.state.sezioneSei.listaOspedalizzato[0].dataOspedalizzato === "" ||
                                            this.state.sezioneSei.listaOspedalizzato[0].dataOspedalizzato == null) ? false :
                                            Utils.isDateInValid(Utils.transformDateForBackend(this.state.sezioneSei.listaOspedalizzato[0].dataOspedalizzato), "-")}>
                                    </Calendar>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-4">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                        <b>  {t("SchedaEpatite.sezione6.ospedale")}: </b></p>
                                </div>
                                <div className={`col-lg-7 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                                    {(this.state.sezioneSei.listaOspedalizzato[1].ospedaleTipo && this.state.sezioneSei.listaOspedalizzato[1].ospedaleTipo.codice) || !this.state.sezioneSei.listaOspedalizzato[1].ospedaleTipo || this.state.controlloAutocomplete.ospedaleTipo1 ?

                                        <Autocomplete id={"ospedaleTipo1"}
                                                      value={this.state.sezioneSei.listaOspedalizzato[1].ospedaleTipo}
                                                      keyField={"codice"}
                                                      descriptionField={"descrizione"}
                                                      suggestionField={"descrizione"}
                                                      onChange={this.riceviValoreInput}
                                                      field={"ospedaleTipo1"}
                                                      placeholder={"Ospedale"}
                                                      suggestions={this.state.struttureAndStabilimenti}
                                        />
                                        :
                                        <Input
                                            id={"ospedaleTipo1"} field={"ospedaleTipo1"}
                                            onChange={this.riceviValoreInput}
                                            value={this.state.sezioneSei.listaOspedalizzato[1].ospedaleTipo}
                                            placeholder={"Ospedale"}
                                        >
                                        </Input>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                        <b> {t("SchedaEpatite.sezione6.reparto")}: </b>
                                    </p>
                                </div>
                                <div className={`col-lg-7 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                    {(this.state.sezioneSei.listaOspedalizzato[1].repartoTipo && Utils.arrayToMap(OggettiUtili.repartoSEIVA, "codice")[this.state.sezioneSei.listaOspedalizzato[1].repartoTipo]) || !this.state.sezioneSei.listaOspedalizzato[1].repartoTipo || this.state.controlloAutocomplete.repartoTipo1 ?

                                        <SelectAutocomplete
                                            id={"repartoTipo1"}
                                            field={"repartoTipo1"}
                                            onChange={this.riceviValoreInput}
                                            newSelect={true}
                                            value={this.state.sezioneSei.listaOspedalizzato[1].repartoTipo}
                                            functionMap={Utils.sortByKey(OggettiUtili.repartoSEIVA, "descrizione").map((oggetto) => {
                                                return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                            })}/>
                                        :
                                        <Input id={"repartoTipo1"} field={"repartoTipo1"}
                                               onChange={this.riceviValoreInput}
                                               value={this.state.sezioneSei.listaOspedalizzato[1].repartoTipo}
                                               placeholder={"Reparto"}
                                        >
                                        </Input>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                        <b> {t("SchedaEpatite.sezione6.quando")}: </b></p>
                                </div>
                                <div className={`col-lg-7 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                    <Calendar
                                        id="dataOspedalizzato1"
                                        field={"dataOspedalizzato1"}
                                        value={this.state.sezioneSei.listaOspedalizzato[1].dataOspedalizzato}
                                        onChange={this.riceviValoreInput}
                                        errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                            "Data")}
                                        error={(this.state.sezioneSei.listaOspedalizzato[1].dataOspedalizzato === "" ||
                                            this.state.sezioneSei.listaOspedalizzato[1].dataOspedalizzato == null) ? false :
                                            Utils.isDateInValid(Utils.transformDateForBackend(this.state.sezioneSei.listaOspedalizzato[1].dataOspedalizzato), "-")}>
                                    </Calendar>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-4">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                        <b>  {t("SchedaEpatite.sezione6.ospedale")}: </b>
                                    </p>
                                </div>
                                <div className={`col-lg-7 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                                    {(this.state.sezioneSei.listaOspedalizzato[2].ospedaleTipo && this.state.sezioneSei.listaOspedalizzato[2].ospedaleTipo.codice) || !this.state.sezioneSei.listaOspedalizzato[2].ospedaleTipo || this.state.controlloAutocomplete.ospedaleTipo2 ?

                                        <Autocomplete id={"ospedaleTipo2"}
                                                      value={this.state.sezioneSei.listaOspedalizzato[2].ospedaleTipo}
                                                      keyField={"codice"}
                                                      descriptionField={"descrizione"}
                                                      suggestionField={"descrizione"}
                                                      onChange={this.riceviValoreInput}
                                                      field={"ospedaleTipo2"}
                                                      placeholder={"Ospedale"}
                                                      suggestions={this.state.struttureAndStabilimenti}/>
                                        :
                                        <Input
                                            id={"ospedaleTipo2"} field={"ospedaleTipo2"}
                                            onChange={this.riceviValoreInput}
                                            value={this.state.sezioneSei.listaOspedalizzato[2].ospedaleTipo}
                                            placeholder={"Ospedale"}
                                        >
                                        </Input>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                        <b> {t("SchedaEpatite.sezione6.reparto")}:</b>
                                    </p>
                                </div>
                                <div className={`col-lg-7 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                    {(this.state.sezioneSei.listaOspedalizzato[2].repartoTipo && Utils.arrayToMap(OggettiUtili.repartoSEIVA, "codice")[this.state.sezioneSei.listaOspedalizzato[2].repartoTipo]) || !this.state.sezioneSei.listaOspedalizzato[2].repartoTipo || this.state.controlloAutocomplete.repartoTipo2 ?

                                        <SelectAutocomplete
                                            id={"repartoTipo2"}
                                            field={"repartoTipo2"}
                                            onChange={this.riceviValoreInput}
                                            newSelect={true}
                                            value={this.state.sezioneSei.listaOspedalizzato[2].repartoTipo}
                                            functionMap={Utils.sortByKey(OggettiUtili.repartoSEIVA, "descrizione").map((oggetto) => {
                                                return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                            })}/>
                                        :
                                        <Input id={"repartoTipo2"} field={"repartoTipo2"}
                                               onChange={this.riceviValoreInput}
                                               value={this.state.sezioneSei.listaOspedalizzato[2].repartoTipo}
                                               placeholder={"Reparto"}
                                        >
                                        </Input>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                        <b> {t("SchedaEpatite.sezione6.quando")}: </b>
                                    </p>
                                </div>
                                <div className={`col-lg-7 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                    <Calendar
                                        id="dataOspedalizzato2" field={"dataOspedalizzato2"}
                                        value={this.state.sezioneSei.listaOspedalizzato[2].dataOspedalizzato}
                                        onChange={this.riceviValoreInput}
                                        errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                            "Data")}
                                        error={(this.state.sezioneSei.listaOspedalizzato[2].dataOspedalizzato === "" ||
                                            this.state.sezioneSei.listaOspedalizzato[2].dataOspedalizzato == null) ? false :
                                            Utils.isDateInValid(Utils.transformDateForBackend(this.state.sezioneSei.listaOspedalizzato[2].dataOspedalizzato), "-")}>
                                    </Calendar>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione6.domandaSei")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"droghe1"}
                                             name={"droghe"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "droghe")}
                                             checked={this.state.sezioneSei.droghe === "01"}>
                                </RadioButton>
                                <RadioButton id={"droghe2"}
                                             name={"droghe"} label={t("SchedaEpatite.risposteTipoUno.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "droghe")}
                                             checked={this.state.sezioneSei.droghe === "02"}
                                />
                                <RadioButton id={"droghe3"}
                                             name={"droghe"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
                                             value={"03"}
                                             onClick={() => this.riceviValoreRadioButton("03", "droghe")}
                                             checked={this.state.sezioneSei.droghe === "03"}
                                />
                            </div>
                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione6.siAssunzione")}</b>
                                {this.state.sezioneSei.droghe === "01" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"modalita1"}
                                             name={"modalita"} label={"Endovenosa"}
                                             value={"01"}
                                             disabled={this.state.sezioneSei.droghe !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "modalita")}
                                             checked={this.state.sezioneSei.modalita === "01"}>
                                </RadioButton>
                                <RadioButton id={"modalita2"}
                                             name={"modalita"} label={"Inalazione"}
                                             value={"02"}
                                             disabled={this.state.sezioneSei.droghe !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("02", "modalita")}
                                             checked={this.state.sezioneSei.modalita === "02"}
                                />
                                <RadioButton id={"modalita3"}
                                             name={"modalita"} label={"Entrambe"}
                                             value={"03"}
                                             disabled={this.state.sezioneSei.droghe !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("03", "modalita")}
                                             checked={this.state.sezioneSei.modalita === "03"}
                                />
                                <RadioButton id={"modalita4"}
                                             name={"modalita"} label={"Altro"}
                                             value={"04"}
                                             disabled={this.state.sezioneSei.droghe !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("04", "modalita")}
                                             checked={this.state.sezioneSei.modalita === "04"}
                                />
                                <RadioButton id={"modalita5"}
                                             name={"modalita"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
                                             value={"05"}
                                             disabled={this.state.sezioneSei.droghe !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("05", "modalita")}
                                             checked={this.state.sezioneSei.modalita === "05"}
                                />
                            </div>
                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione6.siContatti")}</b>
                                {this.state.sezioneSei.droghe === "01" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"contatti1"}
                                             name={"contatti"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             disabled={this.state.sezioneSei.droghe !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "contatti")}
                                             checked={this.state.sezioneSei.contatti === "01"}>
                                </RadioButton>
                                <RadioButton id={"contatti2"}
                                             name={"contatti"} label={t("SchedaEpatite.risposteTipoUno.no")}
                                             value={"02"}
                                             disabled={this.state.sezioneSei.droghe !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("02", "contatti")}
                                             checked={this.state.sezioneSei.contatti === "02"}
                                />
                                <RadioButton id={"contatti3"}
                                             name={"contatti"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
                                             value={"03"}
                                             disabled={this.state.sezioneSei.droghe !== "01"}
                                             onClick={() => this.riceviValoreRadioButton("03", "contatti")}
                                             checked={this.state.sezioneSei.contatti === "03"}
                                />
                            </div>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-lg-6" style={{marginTop: "10px"}}>
                            <p className={styles.labelHeader}>
                                <b>{t("SchedaEpatite.sezione6.domandaSette")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"trattamento1"}
                                             name={"trattamento"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "trattamento")}
                                             checked={this.state.sezioneSei.trattamento === "01"}>
                                </RadioButton>
                                <RadioButton id={"trattamento2"}
                                             name={"trattamento"} label={t("SchedaEpatite.risposteTipoUno.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "trattamento")}
                                             checked={this.state.sezioneSei.trattamento === "02"}
                                />
                                <RadioButton id={"trattamento3"}
                                             name={"trattamento"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
                                             value={"03"}
                                             onClick={() => this.riceviValoreRadioButton("03", "trattamento")}
                                             checked={this.state.sezioneSei.trattamento === "03"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6" style={{marginTop: "10px"}}>
                            <p className={styles.labelHeader}>
                                <b>{t("SchedaEpatite.sezione6.domandaOtto")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"piercingSi"}
                                             name={"piercing"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "piercing")}
                                             checked={this.state.sezioneSei.piercing === "01"}>
                                </RadioButton>
                                <RadioButton id={"piercingNo"}
                                             name={"piercing"} label={t("SchedaEpatite.risposteTipoUno.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "piercing")}
                                             checked={this.state.sezioneSei.piercing === "02"}
                                />
                                <RadioButton id={"piercingNonSo"}
                                             name={"piercing"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
                                             value={"03"}
                                             onClick={() => this.riceviValoreRadioButton("03", "piercing")}
                                             checked={this.state.sezioneSei.piercing === "03"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6" style={{marginTop: "10px"}}>
                            <p className={styles.labelHeader}>
                                <b>{t("SchedaEpatite.sezione6.domandaNove")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"tatuaggioSi"}
                                             name={"tatuaggio"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "tatuaggio")}
                                             checked={this.state.sezioneSei.tatuaggio === "01"}>
                                </RadioButton>
                                <RadioButton id={"tatuaggioNo"}
                                             name={"tatuaggio"} label={t("SchedaEpatite.risposteTipoUno.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "tatuaggio")}
                                             checked={this.state.sezioneSei.tatuaggio === "02"}
                                />
                                <RadioButton id={"tatuaggioNonSo"}
                                             name={"tatuaggio"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
                                             value={"03"}
                                             onClick={() => this.riceviValoreRadioButton("03", "tatuaggio")}
                                             checked={this.state.sezioneSei.tatuaggio === "03"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6" style={{marginTop: "10px"}}>
                            <p className={styles.labelHeader}>
                                <b>{t("SchedaEpatite.sezione6.domandaDieci")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"agoPunturaSi"}
                                             name={"agoPuntura"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "agoPuntura")}
                                             checked={this.state.sezioneSei.agoPuntura === "01"}>
                                </RadioButton>
                                <RadioButton id={"agoPunturaNo"}
                                             name={"agoPuntura"} label={t("SchedaEpatite.risposteTipoUno.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "agoPuntura")}
                                             checked={this.state.sezioneSei.agoPuntura === "02"}
                                />
                                <RadioButton id={"agoPunturaNonSo"}
                                             name={"agoPuntura"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
                                             value={"03"}
                                             onClick={() => this.riceviValoreRadioButton("03", "agoPuntura")}
                                             checked={this.state.sezioneSei.agoPuntura === "03"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6" style={{marginTop: "10px"}}>
                            <p className={styles.labelHeader}>
                                <b>{t("SchedaEpatite.sezione6.domandaUndici")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"barbiereSi"}
                                             name={"barbiere"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "barbiere")}
                                             checked={this.state.sezioneSei.barbiere === "01"}>
                                </RadioButton>
                                <RadioButton id={"barbiereNo"}
                                             name={"barbiere"} label={t("SchedaEpatite.risposteTipoUno.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "barbiere")}
                                             checked={this.state.sezioneSei.barbiere === "02"}
                                />
                                <RadioButton id={"barbiereNonSo"}
                                             name={"barbiere"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
                                             value={"03"}
                                             onClick={() => this.riceviValoreRadioButton("03", "barbiere")}
                                             checked={this.state.sezioneSei.barbiere === "03"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6" style={{marginTop: "10px"}}>
                            <p className={styles.labelHeader}>
                                <b>{t("SchedaEpatite.sezione6.domandaDodici")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"callistaSi"}
                                             name={"callista"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "callista")}
                                             checked={this.state.sezioneSei.callista === "01"}>
                                </RadioButton>
                                <RadioButton id={"callistaNo"}
                                             name={"callista"} label={t("SchedaEpatite.risposteTipoUno.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "callista")}
                                             checked={this.state.sezioneSei.callista === "02"}
                                />
                                <RadioButton id={"callistaNonSo"}
                                             name={"callista"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
                                             value={"03"}
                                             onClick={() => this.riceviValoreRadioButton("03", "callista")}
                                             checked={this.state.sezioneSei.callista === "03"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6" style={{marginTop: "10px"}}>
                            <p className={styles.labelHeader}>
                                <b>{t("SchedaEpatite.sezione6.domandaTredici")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"emodializzatoSi"}
                                             name={"emodializzato"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "emodializzato")}
                                             checked={this.state.sezioneSei.emodializzato === "01"}>
                                </RadioButton>
                                <RadioButton id={"emodializzatoNo"}
                                             name={"emodializzato"} label={t("SchedaEpatite.risposteTipoUno.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "emodializzato")}
                                             checked={this.state.sezioneSei.emodializzato === "02"}
                                />
                                <RadioButton id={"emodializzatoNonSo"}
                                             name={"emodializzato"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
                                             value={"03"}
                                             onClick={() => this.riceviValoreRadioButton("03", "emodializzato")}
                                             checked={this.state.sezioneSei.emodializzato === "03"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        return <div>

            {sezioneSei}
        </div>
    }


}

export default withTranslation('common')(SezioneSei)
